const UserProfileStructure = {
    profileId: "",         // Unique profile ID
    profileUUID: "",       // UUID for the profile
    profileImage: "",
    userId: "",            // Associated user ID
    lastAccessed: "",      // ISO timestamp of last access
    bio: "",               // Brief biography or description
    supportedType: [],     // List of supported media types (e.g., ["image", "video"])
    profileType: "",       // Type of profile (e.g., "creator", "viewer")
    connections: {
      // Define as needed based on connection types
      friends: [],         // Array of friend user IDs
      admirer: [],       // Array of follower user IDs
    },
    created: "",           // Profile creation timestamp (ISO string)
    updated: "",           // Last updated timestamp (ISO string)
    blogs: [
      {
        blogId: "",
        blogUuid: "",
        blogUrl: "",
        title: "",
        authorId: "",
        authorName: "",
        content: "",
        tags: [],
        createdAt: "",
        updatedAt: "",
        publishedAt: "",
        status: "",
        thumbnailUrl: "",
        category: "",
        commentsCount: 0,
        likesCount: 0,
        sharesCount: 0
      }
    ],  
    audios: [],  
    videos: [],  
    images: [],  
    reels: [],
  };
  